"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HttpWrapper_1 = __importDefault(require("./http/HttpWrapper"));
var i18n_1 = __importDefault(require("../utils/i18n"));
var TranslationManager = /** @class */ (function () {
    function TranslationManager() {
        this.currentLocale = 'en';
    }
    TranslationManager.getInstance = function () {
        if (!TranslationManager.instance) {
            TranslationManager.instance = new TranslationManager();
        }
        return TranslationManager.instance;
    };
    TranslationManager.prototype.initialize = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var path, locale, supportedLangs, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = config.path, locale = config.locale, supportedLangs = config.supportedLangs, options = config.options;
                        this.pathToFile = path;
                        this.supportedLangs = supportedLangs;
                        if (locale && this.isSupportedLocale(locale)) {
                            this.currentLocale = locale;
                        }
                        else {
                            this.currentLocale = this.getUserLocale();
                        }
                        return [4 /*yield*/, this.loadTranslations(options)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, i18n_1.default.initialize(TranslationManager.translations, this.currentLocale)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TranslationManager.prototype.localize = function (key, arg) {
        return i18n_1.default.localize(key, arg);
    };
    TranslationManager.prototype.getUserLocale = function () {
        var _this = this;
        var _a;
        if ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.languages) {
            var locale = window.navigator.languages.find(function (item) { return _this.isSupportedLocale(item) || _this.isSupportedLocale(_this.getLanguageShortCode(item)); });
            if (locale) {
                return this.supportedLangs.includes(locale) ? locale : this.getLanguageShortCode(locale);
            }
        }
        if (this.isSupportedLocale(window.navigator.language)) {
            return window.navigator.language;
        }
        var userLocale = this.getLanguageShortCode(window.navigator.language);
        return this.isSupportedLocale(userLocale) ? userLocale : this.supportedLangs[0];
    };
    TranslationManager.prototype.loadTranslations = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var blob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, HttpWrapper_1.default.getFile("".concat(this.pathToFile, "/").concat(this.currentLocale, ".json"), options)];
                    case 1:
                        blob = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                reader.addEventListener('loadend', function (event) {
                                    TranslationManager.translations = JSON.parse(event.target.result);
                                    resolve(TranslationManager.translations);
                                });
                                reader.onerror = function (e) {
                                    reject(e);
                                };
                                reader.readAsText(blob);
                            })];
                }
            });
        });
    };
    TranslationManager.prototype.getLanguageShortCode = function (languageCode) {
        return languageCode.split('-')[0];
    };
    TranslationManager.prototype.isSupportedLocale = function (locale) {
        return this.supportedLangs.indexOf(locale) >= 0;
    };
    TranslationManager.prototype.getCurrentLocale = function () {
        return this.currentLocale;
    };
    return TranslationManager;
}());
exports.default = TranslationManager;
